<template>
  <div v-if="_customer">
    <div class="flex flex-wrap items-start">
      <b class="text-title whitespace-nowrap mr-1">Accounting Key:</b>
      <div class="flex items-center gap-1">
        <span data-cy="accountingKeyText">{{
          _customer.accounting_key || "Not Available"
        }}</span>
        <i
          v-if="_customer.links?.set_accounting_key"
          class="far fa-pen-to-square link"
          data-cy="accountingKeyEditIcon"
          @click="toggleOpen"
        ></i>
      </div>
      <QBSyncBadge
        :synced="_customer.qbo_sync_status === 'succeeded' || true"
        :url="_customer.qbo_url"
        class="w-full pt-1"
      />
    </div>
    <AccountingKeyModal
      v-if="open"
      data-cy="accountingKeyModal"
      :customer="_customer"
      @save-success="emit('save-success')"
      @hide-modal="toggleOpen"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import QBSyncBadge from "@/Quickbooks/QBSyncBadge.vue";
import { Customer } from "@/typings/customer";
import AccountingKeyModal from "./AccountingKeyModal.vue";

const emit = defineEmits(["save-success"]);
const props = withDefaults(
  defineProps<{
    customer: Customer | null;
  }>(),
  { customer: null }
);
// Map props to computed to make it reactive
const _customer = computed(() => props.customer);
// This line is only to appease the compiler
// props are automatically exposed to the template
defineExpose({ customer: props.customer, emit });

const open = ref(false);

function toggleOpen() {
  open.value = !open.value;
}
</script>
